import { useState } from "react";
import { FormHandles } from "@unform/core";
import { useToast } from "../../../shared/hooks";
import LoadingDialog from "../../../shared/components/LoadingModalDialog/LoadingModalDialog";

export function useAddressLookup(formRef?: React.RefObject<FormHandles>) {
	const toastHandler = useToast();
	const [isLoading, setLoading] = useState(false);

	const handleCepLookup = async (cepRaw: string) => {
		const cep = cepRaw.replace(/\D/g, "");

		if (cep.length !== 8) {
			resetAddressFields();
			showError("CEP incompleto. Por favor, insira 8 dígitos.");
			return;
		}

		setLoading(true);

		try {
			const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
			const data = await response.json();

			if (data.erro) {
				resetAddressFields();
				showError("CEP não encontrado!");
				return;
			}

			await waitForFormRef();

			// 🔹 Atualiza os campos no form principal
			requestAnimationFrame(() => {
				if (!formRef?.current) return;

				formRef.current.setFieldValue("address_zipcode", data.cep || "");
				formRef.current.setFieldValue("address_street", data.logradouro || "");
				formRef.current.setFieldValue("address_district", data.bairro || "");
				formRef.current.setFieldValue("address_city", data.localidade || "");
				formRef.current.setFieldValue("address_state", data.uf || "");
				formRef.current.setFieldValue("address_ibge", data.ibge || "");

				// 🔹 Foca automaticamente no campo de número
				formRef.current.getFieldRef("address_number")?.focus?.();
			});
		} catch (error) {
			resetAddressFields();
			showError("Erro ao buscar CEP!");
		} finally {
			setLoading(false);
		}
	};

	// ⏳ Aguarda o formRef inicializar
	const waitForFormRef = async (retries = 10, delay = 100) => {
		for (let i = 0; i < retries; i++) {
			if (formRef?.current) return;
			await new Promise((resolve) => setTimeout(resolve, delay));
		}
	};

	const showError = (message: string) => {
		toastHandler.present({
			type: "error",
			position: "top-right",
			messageOrContent: message,
		});
	};

	const resetAddressFields = () => {
		if (!formRef?.current) return;
		formRef.current.setFieldValue("address_street", "");
		formRef.current.setFieldValue("address_district", "");
		formRef.current.setFieldValue("address_city", "");
		formRef.current.setFieldValue("address_state", "");
		formRef.current.setFieldValue("address_ibge", "");
		formRef.current.setFieldValue("address_residence_type", "");
	};

	const Loading = () => <LoadingDialog isLoading={isLoading} loadingText="Localizando endereço..." />;

	return { handleCepLookup, isLoading, Loading };
}
